import 'css-chunksrc/client/pages/listPage/styles.scss';export default {
  "list": "_list_h84ko_1",
  "listLoading": "_listLoading_h84ko_9",
  "loader": "_loader_h84ko_15",
  "loaderMain": "_loaderMain_h84ko_29",
  "main": "_main_h84ko_36",
  "content": "_content_h84ko_43",
  "secondaryCriteria": "_secondaryCriteria_h84ko_49",
  "label": "_label_h84ko_54",
  "row": "_row_h84ko_60",
  "configurationIconBox": "_configurationIconBox_h84ko_71",
  "configurationIcon": "_configurationIcon_h84ko_71",
  "scrollWrapper": "_scrollWrapper_h84ko_89",
  "timeline": "_timeline_h84ko_98",
  "timestamp": "_timestamp_h84ko_105",
  "comments": "_comments_h84ko_113",
  "header": "_header_h84ko_121",
  "contentHeader": "_contentHeader_h84ko_134",
  "title": "_title_h84ko_142",
  "rightContent": "_rightContent_h84ko_150",
  "profileNavigation": "_profileNavigation_h84ko_157",
  "contentProjectRedirection": "_contentProjectRedirection_h84ko_165",
  "contentModal": "_contentModal_h84ko_169",
  "attachments": "_attachments_h84ko_176",
  "folderIcon": "_folderIcon_h84ko_180",
  "icon": "_icon_h84ko_184",
  "scenePlaceholder": "_scenePlaceholder_h84ko_190"
};